// The company a partner login is working for, when it belongs to several.
// Sent as x-partner-account on API calls and as the aone_partner_acct cookie
// for links the browser opens itself (images, video, downloads). The server
// only ever SELECTS among the login's own memberships with it.
const KEY = 'aone_partner_account';
export function activePartnerAccount() {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
}
export function setActivePartnerAccount(id) {
  try { if (id) localStorage.setItem(KEY, id); else localStorage.removeItem(KEY); } catch { /* storage blocked */ }
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = id ? `aone_partner_acct=${encodeURIComponent(id)}; Path=/; SameSite=Lax${secure}; Max-Age=31536000` : `aone_partner_acct=; Path=/; Max-Age=0${secure}`;
}
